import config from 'cio/config/environment';
import { OAuthProvider, Provider } from 'cio/utils/oauth';

export default class GoogleAdsOauth extends OAuthProvider {
  name = Provider.GoogleAds;
  baseUrl = 'https://accounts.google.com/o/oauth2/v2/auth';
  clientId = config.oAuth.googleAds.clientId;
  scope = 'https://www.googleapis.com/auth/adwords';
  extraParams = {
    access_type: 'offline',
    include_granted_scopes: true,
    prompt: 'consent',
  };
}
